import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import ApiEndpoints from "components/Api";
import SongSelectModal from "components/SongSelectModal";
import useSongParts from "components/useSongParts";
import useLoading from "components/Loading";

const ModeratorSingingPeriodSongsTable = ({ period, onChange }) => {
  const { dayParts } = useSongParts();
  const [adding, setAdding] = useState(false);
  const [selectedPartId, setSelectedPartId] = useState("");
  const [selectedSong, setSelectedSong] = useState(null);
  const [showSongModal, setShowSongModal] = useState(false);
  const [showLoading, hideLoading, Loading] = useLoading();

  const sortedParts = [...dayParts].sort((a, b) => a.defaultOrder - b.defaultOrder);

  const songs = [...(period?.singDaySongs || [])].sort(
    (a, b) => (a.partOrder ?? 0) - (b.partOrder ?? 0)
  );

  const openSongModal = () => setShowSongModal(true);
  const closeSongModal = () => setShowSongModal(false);

  const removeSong = async (singDaySong) => {
    if (!period?.singingPeriodId) return;
    try {
      const token = localStorage.getItem("authToken");
      showLoading();
      const sdsId = singDaySong.id !== undefined ? singDaySong.id : singDaySong.singDaySongId;
      const response = await axios.delete(
        ApiEndpoints.MODERATOR_SINGING_PERIOD_SONG(period.singingPeriodId, sdsId),
        { headers: { Authorization: `Bearer ${token}` } }
      );
      hideLoading();
      if (onChange) onChange(response.data);
    } catch (e) {
      hideLoading();
    }
  };

  const saveSong = async () => {
    if (!period?.singingPeriodId || !selectedSong || !selectedPartId) return;
    const part = dayParts.find((p) => Number(p.id) === Number(selectedPartId));
    const partOrder = part?.defaultOrder ?? 9999;
    try {
      const token = localStorage.getItem("authToken");
      showLoading();
      const response = await axios.put(
        ApiEndpoints.MODERATOR_SINGING_PERIOD_ADD_SONG(period.singingPeriodId),
        {
          songId: selectedSong.id,
          partName: part?.name,
          partOrder,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      hideLoading();
      setAdding(false);
      setSelectedSong(null);
      setSelectedPartId("");
      if (onChange) onChange(response.data);
    } catch (e) {
      hideLoading();
    }
  };

  const cancelAdd = () => {
    setAdding(false);
    setSelectedSong(null);
    setSelectedPartId("");
  };

  return (
    <div>
      <Loading />
      <div style={{ marginBottom: "0.5rem" }}>
        {!adding && (
          <Button
            color="success"
            variant="contained"
            size="small"
            onClick={() => setAdding(true)}
          >
            Dodaj
          </Button>
        )}
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Część</TableCell>
            <TableCell>Pieśń</TableCell>
            <TableCell>Akcje</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {songs.map((s) => (
            <TableRow key={s.id || s.singDaySongId}>
              <TableCell>{s.id || s.singDaySongId}</TableCell>
              <TableCell>{s.partName}</TableCell>
              <TableCell>{s.song?.name || ""}</TableCell>
              <TableCell>
                <Button
                  color="success"
                  variant="contained"
                  size="small"
                  onClick={() => removeSong(s)}
                >
                  Usuń
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {adding && (
            <TableRow>
              <TableCell>Nowy</TableCell>
              <TableCell>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <Select
                    displayEmpty
                    value={selectedPartId}
                    onChange={(e) => setSelectedPartId(e.target.value)}
                    renderValue={(value) => {
                      if (!value) {
                        return "Wybierz";
                      }
                      const part = sortedParts.find((p) => String(p.id) === String(value));
                      return part ? part.name : "Wybierz";
                    }}
                  >
                    <MenuItem value="" disabled>
                      Wybierz
                    </MenuItem>
                    {sortedParts.map((p) => (
                      <MenuItem key={p.id} value={p.id}>
                        {p.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>
                {!selectedSong ? (
                  <Button
                    color="success"
                    variant="contained"
                    size="small"
                    onClick={openSongModal}
                  >
                    Wybierz pieśń
                  </Button>
                ) : (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "0.25rem" }}>{selectedSong.name}</span>
                    <IconButton size="small" onClick={() => setSelectedSong(null)}>
                      <Icon fontSize="small">close</Icon>
                    </IconButton>
                  </div>
                )}
              </TableCell>
              <TableCell>
                <Button
                  color="success"
                  variant="contained"
                  size="small"
                  onClick={saveSong}
                  style={{ marginRight: "0.25rem" }}
                >
                  Zapisz
                </Button>
                <Button
                  color="success"
                  variant="outlined"
                  size="small"
                  onClick={cancelAdd}
                >
                  Anuluj
                </Button>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <SongSelectModal
        open={showSongModal}
        onClose={closeSongModal}
        onSelect={(song) => {
          setSelectedSong(song);
          closeSongModal();
        }}
      />
    </div>
  );
};

export default ModeratorSingingPeriodSongsTable;
